import React, { FC, PropsWithChildren } from 'react';
import MediaQuery from 'react-responsive';

import { t } from 'ttag';

import Icon from '../ui/icon/icon';

import { MEDIA_WIDTH } from '../../lib/constants';
import FlexBox from '../FlexBox/FlexBox';

import VchasnoIcon from './images/vchasno.svg';

import partnersLogo from '../../images/auth/partners.png';

import css from './AuthLayout.css';

const AuthLayout: FC<PropsWithChildren<unknown>> = ({ children }) => (
    <div className={css.root}>
        <FlexBox className={css.container} gap={0}>
            <div className={css.content}>{children}</div>
            <MediaQuery minWidth={MEDIA_WIDTH.tablet + 1}>
                <FlexBox direction="column" align="center" grow={1} gap={0}>
                    <img
                        src={partnersLogo}
                        className={css.image}
                        alt="логотипи партнерів"
                    />
                    <FlexBox
                        className={css.sloganContainer}
                        direction="column"
                        gap={12}
                    >
                        <Icon className={css.vchasnoIcon} glyph={VchasnoIcon} />
                        <h2>{t`Наша мета — ваш успіх`}</h2>
                        <h3>{t`Долучайся до Вчасно і зростай разом з нами!`}</h3>
                    </FlexBox>
                </FlexBox>
            </MediaQuery>
        </FlexBox>
    </div>
);

export default AuthLayout;
